import React, { useState, useEffect, useCallback, useRef } from "react";
import style from "./MyLearning.module.css";
import { GoXCircle } from "react-icons/go";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { MdClear, MdShare, MdMoreVert } from "react-icons/md";
import { BiSearch } from "react-icons/bi";
import Loader from "../Loder/Loader";
import { Doughnut } from "react-chartjs-2";
import { BsCheckCircle } from "react-icons/bs";
import useRazorpay from "react-razorpay";
import learnersLOgo from "../../assests/1o1LearnersClub-Logo1-100-×-100px-2-300x300.png";
import { googleLogout } from "@react-oauth/google";
import { encryptJsonData } from "../EncryptionUtils";
import { getCountryCode } from "../CountryDetails";
import { baseurl, appUrl } from "../Url";
import { logActivity } from "../../services/activityService";
import { AnimationData } from "../../Animation/AnimationData";
import Lottie from "lottie-react";
import { IoPersonCircleOutline } from "react-icons/io5";
import goldMedal from "../../assests/goldnew-removebg-preview.png";
import silverMedal from "../../assests/silvercutnew-removebg-preview.png";
import brownsMedal from "../../assests/brownNew-removebg-preview.png";
import { Whiteboard } from "../WhiteBoard/WhiteBoard";
import { BiClipboard } from "react-icons/bi";
import { Snackbar, Alert } from "@mui/material";
import GoalDetail from "../GoalDetails/GoalDetails";

const MyLearning = () => {
  const navigate = useNavigate();
  const { onMenuToggle, sidebarOpen } = useOutletContext() || {};
  const [details, setDetails] = useState([]);
  const [response, setResponse] = useState(null);
  const [cardList, setCardList] = useState(false);
  const [cardListDetail, setCardListDetail] = useState([]);
  const [allCategories, setAllCategories] = useState(false);
  const [aboutExp, setAboutExp] = useState("");
  const [yearExp, setYearExp] = useState("");
  const [profilePopup, setProfilePopup] = useState(false);
  const [sessionExpire, setSessionExpire] = useState(false);
  const [lodaing, setLoading] = useState(true);
  const [pricePopup, setPricePopup] = useState(false);
  const [priceDetails, setPriceDetails] = useState({});
  const [clickedLearningId, setClickedLearningId] = useState("");
  const [clickedCategoryID, setClickedCategoryID] = useState("");
  const UserID = localStorage.getItem("USERID");
  const ClubID = localStorage.getItem("ClubID");
  const OrgID = localStorage.getItem("ORGID");
  const key = JSON.parse(localStorage.getItem("access-token"));
  const [learningId, setLearningId] = useState("");
  const mentor = localStorage.getItem("mentor");
  const learnertoken = localStorage.getItem("learnertoken");
  const clickedItem = localStorage.getItem("clickedItem");
  const clickedItemDes = localStorage.getItem("clickeditemDes");
  const [token, setToken] = useState(learnertoken ? learnertoken : key);
  const location = useLocation();
  const username = location.state?.username;
  const userid = location.state?.userID;
  const peerRole = location.state?.peerRole;
  const learneruserid = localStorage.getItem("learneruserid");
  const [user_ID, setUser_ID] = useState(
    peerRole !== undefined ? learneruserid : UserID
  );
  const [search, setSearch] = useState("");
  const [searchArray, setSearchArray] = useState([]);
  const [searchCompleted, setSearchCompleted] = useState(false);
  const [leaderBoardShow, setLeaderBoardShow] = useState(false);
  const [rewardValues, setRewardValues] = useState([]);
  // const [whiteBoradShow, setWhiteBoardShow] = useState(false);
  const [whiteBoradIconShow, setWhiteBoardIconShow] = useState(true);
  const CountryDetails = localStorage.getItem("countrydetails");
  const clubIdsArray = ClubID?.split(",");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isGoalsValid, setIsGoalsValid] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isConfirmationVisible, setConfirmationVisible] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [shareCopiedId, setShareCopiedId] = useState(null);
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false);
  const [forcedStartedLearningIds, setForcedStartedLearningIds] = useState(() => {
    try {
      const cached = JSON.parse(localStorage.getItem("forcedStartedLearningIds") || "[]");
      return Array.isArray(cached) ? cached.map((id) => String(id)) : [];
    } catch {
      return [];
    }
  });

  const getCourseTitle = (item) => {
    const direct =
      item?.category_details ||
      item?.CategoryName ||
      item?.course_name ||
      item?.title;
    if (typeof direct === "string" && direct.trim()) return direct;

    const c = item?.Categories;
    if (typeof c === "string" && c.trim()) return c;
    if (Array.isArray(c)) {
      const first = c[0];
      if (typeof first === "string") return first;
      if (first && typeof first === "object") {
        return (
          first.category_details ||
          first.Name ||
          first.course_name ||
          first.first_level ||
          first.last_level ||
          "Learning"
        );
      }
    }
    if (c && typeof c === "object") {
      return c.first_level || c.last_level || "Learning";
    }
    return "Learning";
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    try {
      localStorage.setItem(
        "forcedStartedLearningIds",
        JSON.stringify(Array.isArray(forcedStartedLearningIds) ? forcedStartedLearningIds : [])
      );
    } catch { }
  }, [forcedStartedLearningIds]);

  const handleShare = async (item, event) => {
    event?.stopPropagation();
    const learningId = item?.learning_id;
    const userId = UserID || localStorage.getItem("USERID");
    if (!learningId || !userId) return;
    let shareUrl = `${appUrl}/skills/details/${learningId}/${userId}`;
    if (baseurl) {
      try {
        const token = localStorage.getItem("access-token");
        let bearer = token;
        if (token && typeof token === "string" && token.startsWith("{")) {
          try {
            const parsed = JSON.parse(token);
            bearer = parsed?.token ?? parsed ?? token;
          } catch {
            bearer = token;
          }
        }
        const res = await fetch(`${baseurl}/referral/link`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(bearer && { Authorization: `Bearer ${bearer}` }),
          },
          body: JSON.stringify({
            user_id: userId,
            asset_category: "SKILL",
            asset_id: learningId,
          }),
        });
        const data = await res.json();
        if (data.status && data.data?.referral_code) {
          shareUrl = `${shareUrl}?ref=${data.data.referral_code}`;
        }
      } catch (err) {
        console.warn("Referral link fetch failed:", err);
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      setShareCopiedId(learningId);
      setCopySnackbarOpen(true);
      setTimeout(() => {
        setShareCopiedId(null);
        setCopySnackbarOpen(false);
      }, 1200);
    } catch {
      setShareCopiedId(learningId);
      setCopySnackbarOpen(true);
      setTimeout(() => {
        setShareCopiedId(null);
        setCopySnackbarOpen(false);
      }, 1200);
    }
  };
  const totalSteps = 5;
  const [isOpen, setIsOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const preferencesScrollRef = useRef(null);
  const [goalsFormVersion, setGoalsFormVersion] = useState(0);
  const getEmptyFormData = (targetLearningId = "") => ({
    user_id: localStorage.getItem("USERID") || "",
    learning_id: targetLearningId || "",
    learning_objective: [],
    learning_objective_goal: [],
    user_status: [],
    learning_preference: [],
    learning_constraints: [],
  });
  const resetGoalsForm = (targetLearningId = learningId) => {
    setFormData(getEmptyFormData(targetLearningId));
    setCurrentStep(1);
    setGoalsFormVersion((v) => v + 1);
  };
  const openPopup = () => {
    resetGoalsForm(learningId);
    setIsOpen(true);
  };
  const closePopup = () => {
    setIsOpen(false);
    resetGoalsForm(learningId);
  };

  const handleButtonClick = () => {
    logActivity({ module: "MY_LEARNINGS", action: "GOALS_POPUP_OPEN", instance: learningId, remark: "Goals popup opened from learning card" });
    setIsPopupOpen(true); // Open the popup
  };

  const handleResetClick = () => {
    setConfirmationVisible(true); // Show the confirmation popup
  };

  const handleConfirmReset = () => {
    setConfirmationVisible(false);
    resetGoalsForm(learningId);
    deleteUserGoals();
    // alert("Goals have been reset!"); // Replace with actual reset logic
    // Add your reset goals logic here
  };

  const handleCancelReset = () => {
    setConfirmationVisible(false); // Hide the confirmation popup
  };

  const closeGoalPopup = () => {
    setIsPopupOpen(false);
    setConfirmationVisible(false); // Close the popup
    resetGoalsForm(learningId);
  };

  const [formData, setFormData] = useState(getEmptyFormData(""));

  const getStoredAnswer = (stepKey, question) => {
    const existingQuestion = formData[stepKey]?.find(
      (item) => Object.keys(item)[0] === question
    );

    if (!existingQuestion) return "";

    const value = existingQuestion[question];
    if (Array.isArray(value)) return value[0] || "";
    return value || "";
  };

  const handleInputChange = (stepKey, question, value) => {
    setFormData((prev) => {
      const updatedStepData = [...prev[stepKey]];
      const existingQuestion = updatedStepData.find(
        (item) => Object.keys(item)[0] === question
      );

      if (existingQuestion) {
        existingQuestion[question] = Array.isArray(value) ? value : [value];
      } else {
        updatedStepData.push({
          [question]: Array.isArray(value) ? value : [value],
        });
      }

      return { ...prev, [stepKey]: updatedStepData };
    });
  };
  const handlePrimaryGoalToggle = (option, checked) => {
    setFormData((prev) => {
      const updatedStepData = [...prev.learning_objective];
      const existingQuestion = updatedStepData.find(
        (item) => Object.keys(item)[0] === "primary goals"
      );
      const currentValues = existingQuestion?.["primary goals"] || [];
      const nextValues = checked
        ? [...new Set([...currentValues, option])]
        : currentValues.filter((v) => v !== option);

      if (existingQuestion) {
        existingQuestion["primary goals"] = nextValues;
      } else {
        updatedStepData.push({ "primary goals": nextValues });
      }

      return { ...prev, learning_objective: updatedStepData };
    });
  };

  const callUserGoalsAPI = async () => {
    try {
      // Ensure user_id and learning_id are dynamically set
      const userId = localStorage.getItem("USERID") || "";
      const updatedFormData = {
        ...formData,
        user_id: userId,
        learning_id: learningId,
      };

      const response = await fetch(`${baseurl}/api/usergoals`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedFormData),
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data.message);
        const effectiveLearningId =
          updatedFormData?.learning_id ||
          learningId ||
          localStorage.getItem("newLearningId") ||
          "";
        if (effectiveLearningId) {
          setForcedStartedLearningIds((prev) =>
            prev.includes(String(effectiveLearningId))
              ? prev
              : [...prev, String(effectiveLearningId)]
          );
        }
        // Reflect status change immediately for current learning card
        setCardListDetail((prev) =>
          Array.isArray(prev)
            ? prev.map((item) =>
              String(item?.learning_id) === String(effectiveLearningId)
                ? {
                  ...item,
                  Status: item?.Status === "Completed" ? "Completed" : "Started",
                }
                : item
            )
            : prev
        );
        // Sync with backend-calculated values after goal update
        saveCardList(effectiveLearningId);
        closePopup();
        resetGoalsForm(learningId);
        setSnackbarMessage("Goals added successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      } else {
        const errorData = await response.json();
        console.log(errorData.message);
        setSnackbarMessage(errorData.message || "Error adding Goals");
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.log(error.message);
      setSnackbarMessage("An error occurred while adding Goals");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  useEffect(() => {
    if (!isOpen) return;
    const el = preferencesScrollRef.current;
    if (!el) return;
    // Reset to top when changing levels so users see the first field.
    el.scrollTop = 0;
  }, [currentStep, isOpen]);

  const renderMenu = () => {
    switch (currentStep) {
      case 1:
        return (
          <div>
            <div className={style.popupHead}>
              <h2>Your Goals & Objectives</h2>
            </div>
            <div className={style.mainboxCtn}>
              <div className={style.popPara}>
                <p>
                  What are your primary goals for this course? (Select all that
                  apply)
                </p>
              </div>
              <div className={style.ListBox}>
                <ul>
                  {[
                    "Gain foundational knowledge",
                    "Improve practical skills",
                    "Prepare for exams or certifications",
                    "Apply knowledge to real-world projects",
                    "Enhance career prospects",
                    "Explore personal interest",
                  ].map((option) => (
                    <li key={option}>
                      <label>
                        <input
                          type="checkbox"
                          checked={
                            (
                              formData.learning_objective.find(
                                (item) => Object.keys(item)[0] === "primary goals"
                              )?.["primary goals"] || []
                            ).includes(option)
                          }
                          onChange={(e) =>
                            handlePrimaryGoalToggle(option, e.target.checked)
                          }
                        />
                        {option}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
              <div className={style.listOptBox}>
                <div className={style.listOpt}>
                  <p>What specific outcomes do you expect from this course?</p>
                  <select
                    value={getStoredAnswer(
                      "learning_objective",
                      "expected outcomes"
                    )}
                    onChange={(e) =>
                      handleInputChange(
                        "learning_objective",
                        "expected outcomes",
                        e.target.value
                      )
                    }
                  >
                    <option value="" disabled>
                      Choose your learning objective
                    </option>
                    <option>Mastering key concepts</option>
                    <option>Completing a specific project</option>
                    <option>Passing a test</option>
                    <option>Building a portfolio</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className={style.listOpt}>
                  <p>
                    Are there any specific topics or skills you want to focus
                    on?
                  </p>

                  <div className={style.textBox}>
                    <input
                      type="text"
                      placeholder="E.g., Algebra, Calculus, etc."
                      value={getStoredAnswer(
                        "learning_objective",
                        "focus area topics and skills "
                      )}
                      onChange={(e) => {
                        const sanitizedValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                        e.target.value = sanitizedValue;
                        handleInputChange(
                          "learning_objective",
                          "focus area topics and skills ",
                          sanitizedValue
                        );
                      }}
                    />
                  </div>
                </div>

                <div className={style.listOpt}>
                  <p>
                    Do you have a project or problem in mind that you want to
                    work on?
                  </p>
                  <div className={style.textBox}>
                    <input
                      type="text"
                      placeholder="E.g., Solving optimization problems, analyzing data"
                      value={getStoredAnswer(
                        "learning_objective",
                        "project or problem to work on"
                      )}
                      onChange={(e) => {
                        const sanitizedValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                        e.target.value = sanitizedValue;
                        handleInputChange(
                          "learning_objective",
                          "project or problem to work on",
                          sanitizedValue
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <div className={style.popupHead}>
              <h2>Your Career or Application-Oriented Goals</h2>
            </div>

            <div className={style.mainboxCtn}>
              <div className={style.optionSet}>
                <p>Is this course related to your career goals?</p>
                <select
                  value={getStoredAnswer(
                    "learning_objective_goal",
                    "Is this course related to your career goals"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "learning_objective_goal",
                      "Is this course related to your career goals",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose an option
                  </option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>What industry or field are you aiming to work in?</p>
                <select
                  value={getStoredAnswer(
                    "learning_objective_goal",
                    "industry or field aiming"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "learning_objective_goal",
                      "industry or field aiming",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose your industry or field
                  </option>
                  <option>Technology</option>
                  <option>Education</option>
                  <option>Finance</option>
                  <option>Engineering</option>
                  <option>Research</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>
                  Are you preparing for any specific exams, certifications, or
                  competitions ?
                </p>
                <select
                  value={getStoredAnswer(
                    "learning_objective_goal",
                    "preparing for"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "learning_objective_goal",
                      "preparing for",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose the focus area
                  </option>
                  <option>Teaching</option>
                  <option>Research</option>
                  <option>Job-specific</option>
                  <option>Skills</option>
                  <option>Entrepreneurship</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>Do you have a preferred application for your learning ?</p>
                <div className={style.textBox}>
                  <input
                    type="text"
                    placeholder="E.g., SAT, GRE, etc."
                    value={getStoredAnswer(
                      "learning_objective_goal",
                      "application for learning"
                    )}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      e.target.value = sanitizedValue;
                      handleInputChange(
                        "learning_objective_goal",
                        "application for learning",
                        sanitizedValue
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case 3:
        return (
          <div>
            <div className={style.popupHead}>
              <h2>Your Background</h2>
            </div>

            <div className={style.mainboxCtn}>
              <div className={style.optionSet}>
                <p>What is your current level of knowledge in this subject?</p>
                <select
                  value={getStoredAnswer(
                    "user_status",
                    "level of knowledge"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "user_status",
                      "level of knowledge",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose your knowledge level
                  </option>
                  <option>Beginner</option>
                  <option>Intermediate</option>
                  <option>Advanced</option>
                </select>
              </div>
              <div className={style.optionSet}>
                <p>What is your educational background or current role?</p>
                <select
                  value={getStoredAnswer(
                    "user_status",
                    "educational background or current role"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "user_status",
                      "educational background or current role",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose your educational background or current role
                  </option>
                  <option>School student</option>
                  <option>College student</option>
                  <option>Working professional</option>
                  <option>Other</option>
                </select>
              </div>
              <div className={style.optionSet}>
                <p>What is your preferred learning style?</p>
                <select
                  value={getStoredAnswer(
                    "user_status",
                    "learning style"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "user_status",
                      "learning style",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose your learning style
                  </option>
                  <option>Visual</option>
                  <option>Interactive</option>
                  <option>Reading</option>
                  <option>Listening</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>Have you studied or worked on similar topics before?</p>
                <select
                  value={getStoredAnswer(
                    "user_status",
                    "experienced"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "user_status",
                      "experienced",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose your answer
                  </option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>How much time can you dedicate to learning each week?</p>
                <select
                  value={getStoredAnswer(
                    "user_status",
                    "learning time scheduled "
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "user_status",
                      "learning time scheduled ",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose your answer
                  </option>
                  <option>Daily (1-2 hours)</option>
                  <option>Weekly (5-10 hours)</option>
                  <option>Flexible</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>
                  What challenges have you faced in learning this subject in the
                  past, if any?
                </p>
                <div className={style.textBox}>
                  <input
                    type="text"
                    placeholder="Mention if any"
                    value={getStoredAnswer(
                      "user_status",
                      "challenges faced"
                    )}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      e.target.value = sanitizedValue;
                      handleInputChange(
                        "user_status",
                        "challenges faced",
                        sanitizedValue
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case 4:
        return (
          <div>
            <div className={style.popupHead}>
              <h2>Your Preferences</h2>
            </div>

            <div className={style.mainboxCtn}>
              <div className={style.optionSet}>
                <p>How do you prefer the course content to be delivered?</p>
                <div className={style.rad}>
                  <div>
                    <input
                      type="radio"
                      name="delivery"
                      value="Sequential"
                      checked={
                        getStoredAnswer(
                          "learning_preference",
                          "content preference"
                        ) === "Sequential"
                      }
                      onChange={(e) =>
                        handleInputChange(
                          "learning_preference",
                          "content preference",
                          e.target.value
                        )
                      }
                    />
                    Sequential (Start with basics and progressively advance)
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="delivery"
                      value="Modular"
                      checked={
                        getStoredAnswer(
                          "learning_preference",
                          "content preference"
                        ) === "Modular"
                      }
                      onChange={(e) =>
                        handleInputChange(
                          "learning_preference",
                          "content preference",
                          e.target.value
                        )
                      }
                    />
                    Modular (Jump into specific topics of interest)
                  </div>
                </div>
              </div>
              <div className={style.optionSet}>
                <p>Do you prefer a fast-paced or relaxed learning approach?</p>
                <select
                  value={getStoredAnswer(
                    "learning_preference",
                    "learning approach"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "learning_preference",
                      "learning approach",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose a learning approach
                  </option>
                  <option>Fast-paced</option>
                  <option>Relaxed</option>
                  <option>Custom</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>What type of assessment do you find most effective?</p>
                <select
                  value={getStoredAnswer(
                    "learning_preference",
                    "effective assessment type"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "learning_preference",
                      "effective assessment type",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Choose one
                  </option>
                  <option>Quizzes</option>
                  <option>Interactive simulations</option>
                  <option>Real-world projects</option>
                  <option>Case studies</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>
                  Do you prefer individual learning/tasks or group
                  learning/tasks?
                </p>
                <select
                  value={getStoredAnswer(
                    "learning_preference",
                    "learning tasks type preference"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "learning_preference",
                      "learning tasks type preference",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    select one
                  </option>
                  <option>Individual</option>
                  <option>Collaboration</option>
                </select>
              </div>

              <div className={style.optionSet}>
                <p>How would you like feedback on your progress?</p>
                <select
                  value={getStoredAnswer(
                    "learning_preference",
                    "feedback and progress preference"
                  )}
                  onChange={(e) =>
                    handleInputChange(
                      "learning_preference",
                      "feedback and progress preference",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    select
                  </option>
                  <option>Weekly summary</option>
                  <option>Instant feedback</option>
                  <option>Mentorship support</option>
                  <option>No feedback</option>
                </select>
              </div>
            </div>
          </div>
        );
      case 5:
        return (
          <div>
            <div className={style.popupHead}>
              <h2>Your Constraints</h2>
            </div>

            <div className={style.mainboxCtn}>
              <div className={style.optionSet}>
                <p>
                  Do you have any deadlines or timelines for achieving your
                  goals?
                </p>
                <div className={style.textBox}>
                  <input
                    type="text"
                    placeholder="E.g., Complete in 2 months"
                    value={getStoredAnswer(
                      "learning_constraints",
                      "deadlines or timeline "
                    )}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      e.target.value = sanitizedValue;
                      handleInputChange(
                        "learning_constraints",
                        "deadlines or timeline ",
                        sanitizedValue
                      );
                    }}
                  />
                </div>
              </div>
              <div className={style.optionSet}>
                <p>
                  Are there any specific days or times when you prefer learning?
                </p>
                <div className={style.textBox}>
                  <input
                    type="text"
                    placeholder="E.g., Busy on weekends"
                    value={getStoredAnswer(
                      "learning_constraints",
                      "availability limitations"
                    )}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      e.target.value = sanitizedValue;
                      handleInputChange(
                        "learning_constraints",
                        "availability limitations",
                        sanitizedValue
                      );
                    }}
                  />
                </div>
              </div>
              <div className={style.optionSet}>
                <p>
                  Do you face any limitations in accessing certain types of
                  content?
                </p>
                <div className={style.textBox}>
                  <input
                    type="text"
                    placeholder="E.g., Limited internet access"
                    value={getStoredAnswer(
                      "learning_constraints",
                      "accessibilty limitations of content"
                    )}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      e.target.value = sanitizedValue;
                      handleInputChange(
                        "learning_constraints",
                        "accessibilty limitations of content",
                        sanitizedValue
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const [currency, setCurrency] = useState(localStorage.getItem("currency"));
  const sessionHandle = () => {
    const isMentor = localStorage.getItem("mentor") === "true";
    localStorage.removeItem("access-token");
    localStorage.removeItem("ClubID");
    localStorage.removeItem("ORGID");
    localStorage.removeItem("USERID");
    localStorage.removeItem("mentor");
    localStorage.removeItem("roleId");
    localStorage.removeItem("learnertoken");
    localStorage.removeItem("learneruserid");
    localStorage.removeItem("username");
    localStorage.removeItem("newLearningId");
    localStorage.removeItem("MainLevelId");
    localStorage.removeItem("SubLevelId");
    localStorage.removeItem("clickedItem");
    localStorage.removeItem("clickeditemDes");
    localStorage.removeItem("functionCalled");
    localStorage.removeItem("rzp_checkout_anon_id");
    localStorage.removeItem("rzp_device_id");
    googleLogout();
    navigate(isMentor ? "/login/mentor" : "/login");
    window.location.reload();
  };
  useEffect(() => {
    if (CountryDetails === undefined || CountryDetails === null) {
      getCountryCode()
        .then((countryData) => {
          localStorage.setItem("countrydetails", true);
          localStorage.setItem("timezone", countryData.timezone);
          localStorage.setItem("currency", countryData.currency);
          setCurrency(countryData.currency);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [CountryDetails]);

  async function rewardPoint(id) {
    console.log(id);
    await fetch(`${baseurl}/reward/dashboard`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        club_id: clubIdsArray,
        main_topic_id: id,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setRewardValues(data.data);
      });
  }

  async function saveCardList(forceStartedId = "") {
    await fetch(`${baseurl}/userlearning/list`, {
      method: "POST",
      body: JSON.stringify({ user_id: user_ID }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setLoading(false);
        if (
          data.status_code === 401 ||
          data.error === "Signature has expired"
        ) {
          setSessionExpire(true);
        } else {
          const list = (Array.isArray(data.data) ? data.data : []).map((item) => {
            const topics = Array.isArray(item?.Topics) ? item.Topics : [];
            const totalAssessment = topics.reduce((acc, module) => {
              const moduleTopics = Array.isArray(module?.topics) ? module.topics : [];
              return acc + moduleTopics.length;
            }, 0);
            const assessmentDone = topics.reduce((acc, module) => {
              const moduleTopics = Array.isArray(module?.topics) ? module.topics : [];
              return (
                acc +
                moduleTopics.filter((t) => String(t?.status || "").toLowerCase() === "complete").length
              );
            }, 0);
            const goalObj = Array.isArray(item?.Goal) ? item.Goal[0] : null;

            return {
              ...item,
              goal: typeof goalObj === "object" ? goalObj?.goal || "" : goalObj || "",
              timeline: typeof goalObj === "object" ? goalObj?.time_line || "" : "",
              category_details: item?.CourseName || item?.category_details || "",
              total_assessment: totalAssessment,
              assessment_done: assessmentDone,
            };
          });
          const startedSet = new Set(
            [...forcedStartedLearningIds, String(forceStartedId || "")].filter(Boolean)
          );
          const seen = new Set();
          const dedupedList = list
            .filter((item) => {
              const titleKey = String(
                item?.category_details || item?.Categories || item?.title || ""
              )
                .trim()
                .toLowerCase();
              const goalKey = String(item?.goal || "").trim().toLowerCase();
              const key =
                (titleKey && `${titleKey}::${goalKey}`) ||
                item?.learning_id ||
                `${item?.timeline || ""}::${item?.total_assessment || ""}`;
              if (!key || seen.has(key)) return false;
              seen.add(key);
              return true;
            })
            .map((item) => {
              const itemLearningId = String(item?.learning_id || "");
              if (
                itemLearningId &&
                startedSet.has(itemLearningId) &&
                String(item?.Status || "").trim() === "Not Started"
              ) {
                return { ...item, Status: "Started" };
              }
              return item;
            });
          setCardListDetail(dedupedList);
        }
      });
  }
  async function searchModules() {
    const body = {
      org_id: OrgID,
      search: search,
      user_id: UserID,
    };
    console.log(body);
    const newdata = JSON.stringify(body);
    const encryptstring = encryptJsonData(newdata);
    await fetch(`${baseurl}/main/search`, {
      method: "POST",
      body: JSON.stringify({
        keys: encryptstring,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSearchArray(data.data);
        setLoading(false);
        setSearchCompleted(true);
      });
  }
  async function learningGenerate(clickedname, clickeddes) {
    await fetch(`${baseurl}/new/search/learning/mapping`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        club_id: clubIdsArray,
        org_id: OrgID,
        name: clickedname,
        des: clickeddes,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          saveCardList();
          localStorage.removeItem("clickedItem");
          localStorage.removeItem("clickeditemDes");
        }
      });
  }
  async function priceGet() {
    await fetch(`${baseurl}/fetch/price_list`, {
      method: "Post",
      body: JSON.stringify({
        code: currency,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setPriceDetails(data);
        }
      });
  }

  async function deleteUserGoals() {
    const userId = localStorage.getItem("USERID");
    const LearningIdLoc = localStorage.getItem("newLearningId"); // Retrieve user_id from localStorage

    if (!userId || !LearningIdLoc) {
      alert("User ID or Learning ID is missing.");
      return;
    }

    try {
      const response = await fetch(`${baseurl}/api/usergoals-delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: userId,
          learning_id: LearningIdLoc,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // alert(data.message);
        setSnackbarMessage(
          "Goals reset successfully ! You Can Set new goals now."
        );
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setForcedStartedLearningIds((prev) =>
          prev.filter((id) => String(id) !== String(LearningIdLoc))
        );
        resetGoalsForm(learningId);
        closeGoalPopup();
        console.log("Goal deleted successfully:", data);
      } else {
        console.error("Error:", data);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  }

  async function createOrder(
    amount,
    plan,
    currency,
    clickedcategoryID,
    clickedlearningId
  ) {
    const response = await fetch(`${baseurl}/create-order`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        amount: amount,
        learning_id: clickedlearningId,
        category_id: clickedcategoryID,
        plan: plan,
        currency: currency,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    });
    const data = await response.json();
    console.log(data);
    return data.data[0];
  }
  const [Razorpay] = useRazorpay();
  const handlePayment = useCallback(
    async (amount, plan, currency, clickedcategoryID, clickedlearningId) => {
      const order = await createOrder(
        amount,
        plan,
        currency,
        clickedcategoryID,
        clickedlearningId
      );
      // const prefill={
      //   ...prefilldata
      // }

      const options = {
        key: `${import.meta.env.VITE_RAZORPAY_TEST_KEY}`,
        amount: order.amount,
        currency: order.currency,
        name: "1o1 Learners Club",
        description: "Test Transaction",
        image: learnersLOgo,
        order_id: order.razorpay_order_id,
        handler: async function (response) {
          const data = {
            razorpay_signature: response.razorpay_signature,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
          };

          const result = await fetch(`${baseurl}/verify-payment`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              "Content-Type": "application/json",
            },
          });
          const responseData = await result.json();
          console.log(responseData);
          if (responseData.status === true) {
            setPricePopup(false);
            saveCardList();
          }
        },
        prefill: {
          name: "",
          email: "",
          contact: "9999999999",
        },
        notes: {
          address: "1o1 Learners Club",
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzpay = new Razorpay(options);
      rzpay.on("payment.failed", function (response) {
        console.log(response.error.code);
        console.log(response.error.description);
        console.log(response.error.source);
        console.log(response.error.step);
        console.log(response.error.reason);
        console.log(response.error.metadata.order_id);
        console.log(response.error.metadata.payment_id);
      });
      rzpay.open();
    },
    [Razorpay]
  );

  useEffect(() => {
    if (search === "") {
      setSearchCompleted(false);
    }
  }, [search]);

  useEffect(() => {
    console.log(details);
  }, [details]);

  useEffect(() => {
    // Update user_ID when peerRole changes
    setUser_ID(peerRole !== undefined ? learneruserid : UserID);
  }, [peerRole]);

  useEffect(() => {
    const hasFunctionBeenCalled = localStorage.getItem("functionCalled");
    if (
      clickedItem !== undefined &&
      clickedItem !== null &&
      hasFunctionBeenCalled !== "true"
    ) {
      learningGenerate(clickedItem, clickedItemDes);
      localStorage.setItem("functionCalled", "true");
    } else {
      saveCardList();
    }
    setCardList(false);
    // priceGet()
  }, [user_ID]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (search !== "") {
        navigate("/skills", { state: { keyword: search } });
      }
    }
  };
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (closing) {
      setTimeout(() => {
        setClosing(false);
      }, 1000);
    }
  }, [closing]);

  // Open Goals popup when navigated from Dashboard (goal banner Update button)
  useEffect(() => {
    const openGoalsPopup = location.state?.openGoalsPopup;
    if (!openGoalsPopup || !cardListDetail || cardListDetail.length === 0) return;

    const openGoalsFromDashboard = async () => {
      const item = cardListDetail[0];
      const learningIds = item.learning_id;
      const userId = localStorage.getItem("USERID");

      if (!userId || !learningIds) return;

      try {
        localStorage.setItem("newLearningId", learningIds);
        if (item.admin_mapped_lessons) {
          localStorage.setItem("adminmapped", item.admin_mapped_lessons);
        }
        const res = await fetch(`${baseurl}/list/usergoals-check`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userId, learning_id: learningIds }),
        });
        const data = await res.json();
        setLearningId(data.learning_id || learningIds);
        if (!data.status) {
          openPopup();
        } else {
          handleButtonClick();
        }
        navigate("/learnings", { replace: true, state: { ...location.state, openGoalsPopup: false } });
      } catch (err) {
        console.error("Error opening goals popup:", err);
        navigate("/learnings", { replace: true, state: { ...location.state, openGoalsPopup: false } });
      }
    };

    openGoalsFromDashboard();
  }, [cardListDetail, location.state?.openGoalsPopup]);

  return (
    <div className={style.Container}>
      {lodaing ? <Loader /> : ""}
      {profilePopup ? (
        <>
          <div
            className={style.Overlay}
            onClick={() => {
              setProfilePopup(false);
            }}
          ></div>
          <div className={style.AddressSection}>
            <form action="">
              <div className={style.Formtext}>
                <p>Please enter experience details</p>
              </div>
              <input
                type="text"
                name=""
                id=""
                value={yearExp}
                required
                onChange={(e) => {
                  setYearExp(e.target.value);
                }}
                placeholder="Year Of experience"
              />
              <input
                type="text"
                name=""
                id=""
                value={aboutExp}
                required
                onChange={(e) => {
                  setAboutExp(e.target.value);
                }}
                placeholder="About experience"
              />

              <button type="submit">CONFIRM</button>
            </form>
          </div>
        </>
      ) : (
        ""
      )}
      {/* {whiteBoradIconShow ? (
        <div className={style.chatboticon}>
          <div
            onClick={() => {
              setWhiteBoardShow(true);
              setWhiteBoardIconShow(false);
            }}
            className={style.icontext}
          >
            <BiClipboard className={style.WhiteboardFloatingIcon} />
            <p> Whiteboard</p>
          </div>
        </div>
      ) : (
        ""
      )} */}

      {/* {whiteBoradShow ? (
        <div
          className={`${style.WhiteBoradContainer} ${
            closing ? style.closing : ""
          }`}
        >
          <div className={style.WhiteBoradHead}>
            <div className={style.HeadText}>White Board</div>
            <div
              className={style.WhiteBoradIcon}
              onClick={() => {
                setTimeout(() => {
                  setWhiteBoardIconShow(true);
                  setWhiteBoardShow(false);
                }, 500);
                setClosing(true);
              }}
            >
              <AiOutlineClose />
            </div>
          </div>
          <div className={style.WhiteBoradContent}>
            <Whiteboard />
          </div>
        </div>
      ) : (
        ""
      )} */}
      {pricePopup ? (
        <>
          <div
            onClick={() => {
              setPricePopup(false);
              setClickedCategoryID("");
              setClickedLearningId("");
            }}
            className={style.PriceDivOverlay}
          ></div>
          <div className={style.PriceDiv}>
            {priceDetails.data && priceDetails.data_show ? (
              <div className={style.PriceTable}>
                <table>
                  <thead>
                    <th style={{ backgroundColor: "#c7c6c5" }}>
                      <p className={style.TableHeadTextfirst}> PRICING </p>
                      <p className={style.TableHeadTextsecond}>TABLE</p>
                    </th>
                    {priceDetails.data.map((packageData) => {
                      function getHeaderBackgroundColor(packageData) {
                        if (packageData.PackageName === "Free") {
                          return "#34b7eb";
                        } else if (packageData.PackageName === "Basic") {
                          return "green";
                        } else if (packageData.PackageName === "Professional") {
                          return "#ebc230";
                        } else if (packageData.PackageName === "Advanced") {
                          return "red";
                        } else {
                          return "#c7c6c5";
                        }
                      }
                      function CurrencySymbolDisplay({ currencySymbol }) {
                        return (
                          <span
                            style={{ fontSize: "1rem" }}
                            className={style.PriceAmount}
                          >
                            {currencySymbol}
                          </span>
                        );
                      }
                      return (
                        <th
                          key={packageData.PackageCode}
                          style={{
                            backgroundColor:
                              getHeaderBackgroundColor(packageData),
                          }}
                        >
                          <p className={style.PriceText}>
                            {packageData.PackageName}
                          </p>
                          <p className={style.PriceAmount}>
                            {" "}
                            <CurrencySymbolDisplay
                              currencySymbol={packageData.FEE[0].CurrencySymbol}
                            />{" "}
                            {packageData.FEE[0].Amount}
                          </p>
                          <span className={style.PriceMonth}>Per Month</span>
                        </th>
                      );
                    })}
                  </thead>
                  <tbody>
                    {priceDetails.data_show.map((feature) => (
                      <tr key={feature.FeatureCode}>
                        <td>{feature.Name}</td>
                        {priceDetails.data.map((packageData) => (
                          <td key={packageData.PackageCode}>
                            {packageData.Features.some(
                              (f) => f.FeatureCode === feature.FeatureCode
                            ) ? (
                              <span style={{ color: "green" }}>
                                <BsCheckCircle />
                              </span>
                            ) : (
                              <span style={{ color: "red" }}>
                                <GoXCircle />
                              </span>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                    <tr
                      style={{ backgroundColor: "#c7c6c5" }}
                      className={style.ButtonRow}
                    >
                      <td></td>
                      {priceDetails.data.map((packageData) => {
                        function getButtonBackgroundColor(packageData) {
                          if (packageData.PackageName === "Free") {
                            return "#34b7eb";
                          } else if (packageData.PackageName === "Basic") {
                            return "green";
                          } else if (
                            packageData.PackageName === "Professional"
                          ) {
                            return "#ebc230";
                          } else if (packageData.PackageName === "Advanced") {
                            return "red";
                          } else {
                            return "#c7c6c5";
                          }
                        }
                        return (
                          <td
                            key={packageData.PackageCode}
                            style={{
                              backgroundColor:
                                getButtonBackgroundColor(packageData),
                            }}
                          >
                            <button
                              onClick={() => {
                                handlePayment(
                                  packageData.Fee[0].Amount,
                                  packageData.PackageName,
                                  packageData.FEE[0].mode,
                                  clickedCategoryID,
                                  clickedLearningId
                                );
                              }}
                              disabled={packageData.PackageName === "Free"}
                              className={style.TableButton}
                            >
                              Buy Now
                            </button>
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <p>Loading data...</p>
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <div className={style.LearningDiv}>
        <div className={style.Head}>
          {typeof onMenuToggle === "function" && (
            <button
              type="button"
              className={style.mobileHeaderMenuBtn}
              onClick={onMenuToggle}
              aria-label="Open menu"
            >
              <MdMoreVert size={22} />
            </button>
          )}
          <div className={style.Input}>
            <BiSearch className={style.Icons} />
            <input
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setSearchArray([]);
              }}
              onFocus={(e) => {
                e.target.setAttribute("data-placeholder", e.target.placeholder);
                e.target.placeholder = "";
              }}
              onBlur={(e) => {
                e.target.placeholder =
                  e.target.getAttribute("data-placeholder");
              }}
              onKeyDown={handleKeyPress}
              placeholder="what do you want to learn?"
            />
            {search !== "" ? (
              <span
                onClick={() => {
                  setSearch("");
                  setSearchCompleted(false);
                  setSearchArray([]);
                }}
              >
                <MdClear className={style.Icons} />
              </span>
            ) : (
              ""
            )}
          </div>
          {mentor !== "true" ? (
            <div className={style.learningButton}>
              <button
                disabled={search === ""}
                onClick={() => {
                  navigate("/skills", { state: { keyword: search } });
                }}
              >
                Search Topics
              </button>
              {peerRole === "Intern" ? (
                ""
              ) : (
                <button
                  onClick={() => {
                    navigate("/skills");
                  }}
                >
                  Course Gallery
                </button>
              )}
            </div>
          ) : (
            <div className={style.learningButton}>
              <button
                disabled={search === ""}
                onClick={() => {
                  navigate("/skills", { state: { keyword: search } });
                }}
              >
                Search Topics
              </button>
            </div>
          )}
        </div>

        <div className={style.Grid}>
          {cardListDetail && cardListDetail.length > 0 ? (
            (() => {
              const filtered = search
                ? cardListDetail.filter(
                  (item) =>
                    (item.category_details &&
                      item.category_details.toLowerCase().includes(search.trim().toLowerCase())) ||
                    (item.goal && item.goal.toLowerCase().includes(search.trim().toLowerCase()))
                )
                : cardListDetail;
              const toShow = search ? filtered.slice(0, 20) : filtered;
              if (toShow.length === 0) {
                return (
                  <div className={style.ErrorMessage}>
                    <p>No matching topics. Try a different search.</p>
                  </div>
                );
              }
              return toShow.map((item, index) => (
                <div key={index} className={style.Card}>
                  <div className={style.Cardhead}>
                    <div className={style.CardheadText}>
                      <p>{getCourseTitle(item)}</p>
                    </div>
                  </div>

                  <div className={style.cardData}>
                    <div className={style.cardRowGoalChart}>
                      <div className={style.goalColumn}>
                        <span className={style.infoIconLabel}>Goal:</span>
                        <span className={style.infoValue}>{item.goal}</span>
                      </div>
                      <div className={style.chartColumnOnly}>
                        <div className={style.progressSection}>
                          <div className={style.chartWrapper}>
                            <Doughnut
                              data={{
                                labels: ["Completed", "Remaining"],
                                datasets: [
                                  {
                                    data: [
                                      item.assessment_done,
                                      item.total_assessment - item.assessment_done,
                                    ],
                                    backgroundColor: ["#0151CD", "#e2e8f0"],
                                    borderWidth: 0,
                                    cutout: "75%",
                                  },
                                ],
                              }}
                              options={{
                                plugins: {
                                  legend: { display: false },
                                  tooltip: { enabled: false }
                                },
                                maintainAspectRatio: false
                              }}
                            />
                            <div className={style.chartPercentage}>
                              {item.total_assessment !== 0
                                ? `${Math.round((item.assessment_done / item.total_assessment) * 100)}%`
                                : "0%"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={style.cardRowModulesTimeline}>
                      <div className={`${style.infoItem} ${style.modulesCell}`}>
                        <span className={style.infoIconLabel}>Modules:</span>
                        <span className={style.infoValue}>{item.Topics?.length || 0}</span>
                      </div>
                      <div className={style.timelineInlineRight}>
                        <span className={style.infoIconLabel}>Timeline:</span>
                        <span className={style.infoValue}>{item.timeline} Month(s)</span>
                      </div>
                    </div>

                    <div className={style.infoItemProgressRow}>
                      <div className={style.infoItem}>
                        <span className={style.infoIconLabel}>Progress:</span>
                        <span className={style.infoValue}>{item.assessment_done}/{item.total_assessment}</span>
                      </div>
                      <div className={style.statusTag}>
                        {(() => {
                          const rawStatus = (item.Status || "").trim();
                          const statusLabel =
                            rawStatus === "In Progress" ? "Started" : rawStatus;
                          const statusColor =
                            statusLabel === "Not Started"
                              ? "#FF4D4D"
                              : statusLabel === "Started"
                                ? "#FF9F43"
                                : statusLabel === "Completed"
                                  ? "#28C76F"
                                  : "#82868B";
                          return (
                            <>
                              <span
                                className={style.statusIndicator}
                                style={{
                                  backgroundColor: statusColor,
                                }}
                              ></span>
                              <span className={style.statusText}>{statusLabel}</span>
                            </>
                          );
                        })()}
                      </div>
                    </div>

                    <div className={style.buttonGroup}>
                      <button
                        className={style.actionButton}
                        onClick={async () => {
                          const userId = localStorage.getItem("USERID");
                          const learningIds = item.learning_id;

                          if (userId && learningIds) {
                            try {
                              localStorage.setItem("newLearningId", learningIds);
                              const res = await fetch(`${baseurl}/list/usergoals-check`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ user_id: userId, learning_id: learningIds }),
                              });
                              const data = await res.json();
                              if (!data.status) {
                                openPopup();
                                setLearningId(data.learning_id);
                              } else {
                                setLearningId(data.learning_id);
                                const source = peerRole !== undefined ? "support" : "";
                                logActivity({ module: "MY_LEARNINGS", action: "VIEW_COURSE", instance: learningIds, remark: item.title || "" });
                                navigate("/lerning/detail", {
                                  state: {
                                    learning_detail: item,
                                    title: getCourseTitle(item),
                                    peerRole: peerRole,
                                    source,
                                    learningId: data.learning_id,
                                  },
                                });
                                localStorage.setItem("adminmapped", item.admin_mapped_lessons);
                              }
                            } catch (err) {
                              console.log("Error occurred during the API call", err);
                            }
                          }
                        }}
                      >
                        Details
                      </button>

                      <button
                        className={style.secondaryButton}
                        onClick={async () => {
                          const userId = localStorage.getItem("USERID");
                          const learningIds = item.learning_id;

                          if (userId && learningIds) {
                            try {
                              localStorage.setItem("newLearningId", learningIds);
                              const res = await fetch(`${baseurl}/list/usergoals-check`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ user_id: userId, learning_id: learningIds }),
                              });
                              const data = await res.json();
                              if (!data.status) {
                                openPopup();
                                setLearningId(data.learning_id);
                              } else {
                                setLearningId(data.learning_id);
                                localStorage.setItem("newLearningId", item.learning_id);
                                handleButtonClick();
                                localStorage.setItem("adminmapped", item.admin_mapped_lessons);
                              }
                            } catch (err) {
                              console.log("Error occurred during the API call", err);
                            }
                          }
                        }}
                      >
                        Preferences
                      </button>

                      <button
                        className={`${style.secondaryButton} ${style.leaderboardButtonHidden}`}
                        onClick={(event) => {
                          event.stopPropagation();
                          setLeaderBoardShow(true);
                          rewardPoint(item.Topics[0].topic_id);
                        }}
                      >
                        Leaderboard
                      </button>
                      <button
                        className={`${style.secondaryButton} ${style.shareButton} ${shareCopiedId === item.learning_id ? style.shareCopied : ""}`}
                        onClick={(e) => handleShare(item, e)}
                        title={shareCopiedId === item.learning_id ? "Copied!" : "Share"}
                      >
                        <MdShare size={16} style={{ marginRight: "4px" }} />
                        {shareCopiedId === item.learning_id ? "Copied!" : "Share"}
                      </button>
                    </div>
                  </div>
                </div>
              ));
            })()
          ) : (
            <div>{!lodaing ? "No Learning" : ""}</div>
          )}
        </div>
      </div>
      {
        leaderBoardShow ? (
          <>
            <div
              className={style.Overlay}
              onClick={() => {
                setLeaderBoardShow(false);
              }}
            ></div>
            <div className={style.leaderBoard}>
              <div className={style.boardHeader}>
                <h3>LEADER BOARD</h3>
              </div>
              <div className={style.boardSection}>
                {rewardValues &&
                  rewardValues.length > 0 &&
                  rewardValues.map((value, i) => {
                    return (
                      <div className={style.boardValues} key={i}>
                        <div className={style.valueBadge}>
                          {i === 0 ? (
                            <img src={goldMedal} alt="" />
                          ) : i === 1 ? (
                            <img src={silverMedal} alt="" />
                          ) : i === 2 ? (
                            <img src={brownsMedal} alt="" />
                          ) : (
                            <p>{i + 1}</p>
                          )}
                        </div>
                        <div className={style.valueAvatar}>
                          <IoPersonCircleOutline />
                        </div>
                        <div className={style.playerNameStar}>
                          <p>{value.name}</p>
                          <p>{value.point}</p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </>
        ) : (
          ""
        )
      }

      {
        sessionExpire ? (
          <div className={style.session}>
            <div className={style.session_close}>
              <AiOutlineClose onClick={() => setSessionExpire(false)} />
            </div>
            <div className={style.session_content}>
              <p>Session is Expired.Please Log In !</p>
            </div>
            <div className={style.session_button}>
              <button
                onClick={() => {
                  sessionHandle();
                }}
              >
                Log In
              </button>
            </div>
          </div>
        ) : (
          ""
        )
      }

      {copySnackbarOpen && (
        <div className={style.snackbar}>
          <p>Link copied</p>
        </div>
      )}

      {
        isPopupOpen && (
          <div className={style.popupoverlay} onClick={closeGoalPopup}>
            <div
              className={style.popupcontent}
              onClick={(e) => e.stopPropagation()}
            >
              <button className={style.closeButton} onClick={closeGoalPopup}>
                &times;
              </button>
              <GoalDetail onClose={closeGoalPopup} />

              <button className={style.resetBtn} onClick={handleResetClick}>
                Reset Goals
              </button>

              {isConfirmationVisible && (
                <div className={style.confirmationOverlay}>
                  <div className={style.confirmationContent}>
                    <p>Are you sure you want to reset your goals?</p>
                    <div className={style.btnGrp}>
                      <button
                        className={style.cancelButton}
                        onClick={handleCancelReset}
                      >
                        Cancel
                      </button>

                      <button
                        className={style.confirmButton}
                        onClick={handleConfirmReset}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      }

      {
        isOpen && (
          <div className={style.popup}>
            <div className={style.popupContent}>
              <button
                className={style.closeButton}
                onClick={() => {
                  closePopup();
                  setCurrentStep(1);
                }}
                aria-label="Close"
              >
                &times;
              </button>

              <div className={style.progressBox}>
                <div className={style.progressBar}>
                  {Array.from({ length: totalSteps }, (_, index) => (
                    <div
                      key={index + 1}
                      className={`${style.stepNumber} ${currentStep === index + 1 ? style.activeStep : ""
                        }`}
                      onClick={() => setCurrentStep(index + 1)} // Change step on click
                    >
                      {index + 1}
                    </div>
                  ))}
                  <div
                    className={style.progress}
                    style={{
                      width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%`,
                    }}
                  />

                  <div className={style.progress2} />
                </div>
              </div>
              <div className={style.goalbox} ref={preferencesScrollRef}>
                <div key={goalsFormVersion}>{renderMenu()}</div>

                <div className={style.navigationButtons}>
                  <button onClick={prevStep} disabled={currentStep === 1}>
                    Previous
                  </button>
                  {currentStep < totalSteps ? (
                    <button onClick={nextStep}>Next</button>
                  ) : (
                    <button onClick={callUserGoalsAPI}>Finish</button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      }

      <div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </div >
  );
};

export default MyLearning;
